import i18next from 'i18next';
import { OrgHierarchyResponse } from '../../hooks/useMultiOrgHierarchy';
import { AppSection, TenantInfo, NavigationItem } from '../../types';
import { Variant } from '../hooks/useVariant';
import { isMultiEntityEnabled, isMultiOrgEnabled } from '../MultiOrg/utils';
import { convertToBillingUrl } from '../../utils/getBillingBaseUrl';

export class AppSectionFactory {
  static createCommandCenter(): AppSection {
    return {
      name: 'command-center',
      visible: false,
      top: {
        tenants: undefined,
        search: false,
        inbox: {
          visible: false,
        },
      },
      bottom: [
        {
          label: i18next.t('GlobalNav.Sections.CommandCenter'),
          icon: 'commandCenter',
          expandable: false,
          href: '/',
          chip: '',
          pinnable: false,
          divider: false,
        },
        // ... other command center items
      ],
    };
  }

  // static createZuoraHelpChat(): AppSection {
  //   return {
  //     name: 'ai',
  //     visible: false,
  //     top: {
  //       tenants: undefined,
  //       search: false,
  //       multiOrgMenu: false,
  //       inbox: {
  //         visible: false,
  //       },
  //     },
  //     bottom: undefined,
  //   };
  // }

  static createBilling(
    entities: TenantInfo[],
    items: NavigationItem[],
    permissions: any,
    multiOrgHierarchy?: OrgHierarchyResponse,
  ): AppSection {
    return {
      name: 'billing',
      visible: false,
      top: {
        tenants: entities,
        search: true,
        inbox: {
          label: i18next.t('GlobalNav.Sections.ApprovalsCenter'),
          visible: true,
          url: convertToBillingUrl('/platform/apps/workflow/tasks'),
        },
        multiOrgMenu:
          isMultiOrgEnabled(permissions) &&
          !!multiOrgHierarchy?.userOrgIds?.length,
        multiEntityMenu: isMultiEntityEnabled(permissions),
      },
      bottom: items,
    };
  }

  // top section is same as bill section as this is common
  static createPayments(
    entities: TenantInfo[],
    items: NavigationItem[],
    permissions: any,
    multiOrgHierarchy?: OrgHierarchyResponse,
  ): AppSection {
    return {
      name: 'payments',
      visible: false,
      top: {
        tenants: entities,
        search: true,
        inbox: {
          label: i18next.t('GlobalNav.Sections.ApprovalsCenter'),
          visible: true,
          url: convertToBillingUrl('/platform/apps/workflow/tasks'),
        },
        multiOrgMenu:
          isMultiOrgEnabled(permissions) &&
          !!multiOrgHierarchy?.userOrgIds?.length,
        multiEntityMenu: isMultiEntityEnabled(permissions),
      },
      bottom: items,
    };
  }

  static createRevenue(
    entities: TenantInfo[],
    items: NavigationItem[],
    variant: Variant,
  ): AppSection {
    return {
      name: 'revenue',
      visible: false,
      top: {
        tenants: entities,
        search: false,
        accountingDate: 'Oct 2023',
        inbox: {
          label: i18next.t('GlobalNav.Sections.Notifications'),
          visible: true,
          url:
            variant === Variant.ONE_ID_REVENUE
              ? '/revenue/#/notifications'
              : '/revpro/#/notifications',
        },
        approvalsCenter: {
          label: i18next.t('GlobalNav.Sections.ApprovalsCenter'),
          visible: true,
          url: '/platform/apps/workflow/tasks',
        },
      },
      bottom: items,
    };
  }

  static createSettings(
    entities: TenantInfo[],
    settingsItems: any[],
  ): AppSection {
    return {
      name: 'app-settings',
      visible: false,
      top: {
        tenants: entities,
        search: true,
        inbox: {
          visible: false,
        },
      },
      bottom: [],
      settings: [
        {
          name: i18next.t('GlobalNav.Sections.BillingSettings'),
          items: settingsItems,
        },
      ],
    };
  }

  // private static isMultiOrgEnabled(permissions: any): boolean {
  //   // Implementation from your utils
  //   return false; // placeholder
  // }

  // private static isMultiEntityEnabled(permissions: any): boolean {
  //   // Implementation from your utils
  //   return false; // placeholder
  // }
}
